
<template lang="pug">
  .input.input--text(:class="inputClass")
    input(
      type="text",
      :placeholder="placeholder",
      v-model="currentValue",
      :disabled="disabled"
      :required="required"
    )
    label(v-if="labelText") {{ labelText }}
</template>

<script>
  export default {
    name: 'TextInput',
    props: {
      value: [String, Number],
      label: String,
      error: String,
      disabled: Boolean,
      required: Boolean,
      placeholder: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'text'
      }
    },
    data () {
      return {
        initialized: false,
        currentValue: this.value
      }
    },
    computed: {
      labelText () {
        return (this.error) ? this.error : this.label;
      },
      inputClass () {
        return {
          'error': Boolean(this.error)
        };
      }
    },
    watch: {
      currentValue (p, c) {
        this.$emit('input', this.currentValue);
      }
    },
    methods: {
      set (val) {
        this.currentValue = val;
      }
    }
  };
</script>

<style scoped lang="scss">
</style>
